import {createSelector} from "@reduxjs/toolkit";
import {ChatToken} from "../../model/chat/chat-token";
import {getUseQueryResultData} from "../../util/selector-util";
import {ChatConfig} from "../../model/chat/chat-config";

export const chatTokenSelector = () => createSelector(
  [getUseQueryResultData<ChatToken>],
  (data) => {
    return data
  }
);

export const chatConfigSelector = () => createSelector(
  [getUseQueryResultData<ChatConfig>],
  (data) => {
    return data
  }
);
